import { render } from "./Steps.vue?vue&type=template&id=77a8c991&scoped=true"
import script from "./Steps.vue?vue&type=script&lang=js"
export * from "./Steps.vue?vue&type=script&lang=js"

import "./Steps.vue?vue&type=style&index=0&id=77a8c991&scoped=true&lang=css"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a8c991"]])

export default __exports__